import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";
import getProjectId from "./get_project_id";
import { FloorBuiltElementCounts } from "../../reducers/domain/reduce_floor_built_element_counts";

const getFloorBuiltElementCounts = createSelector([
  getDomain,
  getProjectId
], (domain, projectId): FloorBuiltElementCounts => {
  return domain.floorBuiltElementCounts?.byFirebaseProjectId?.[projectId] ?? {};
});

export default getFloorBuiltElementCounts;
